import { render } from "./DashboardAdminComp.vue?vue&type=template&id=8a4759aa&scoped=true"
import script from "./DashboardAdminComp.vue?vue&type=script&lang=js"
export * from "./DashboardAdminComp.vue?vue&type=script&lang=js"

import "./DashboardAdminComp.vue?vue&type=style&index=0&id=8a4759aa&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4759aa"]])

export default __exports__